import script from "./LocationIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./LocationIcon.vue?vue&type=script&setup=true&lang=js"

import "./LocationIcon.vue?vue&type=style&index=0&id=05fefeaa&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05fefeaa"]])

export default __exports__